import { VehicleType } from '@/interfaces/vehicle'

// Map OrderReceiptStatus to Spanish labels
export const VEHICLE_TYPE_LABELS: Record<VehicleType, string> = {
  TRUCK: 'Rastra',
  CAR: 'Carro',
  VAN: 'Van',
  MOTORCYCLE: 'Motor',
  BIKE: 'Bicicleta',
  OTHER: 'Otro',
}

// Generate status options for order status
export const vehicleTypeOptions = [
  { value: 'all', label: 'Todos' },
  ...Object.entries(VEHICLE_TYPE_LABELS).map(([value, label]) => ({
    value,
    label,
  })),
]

// Type for status option
export interface StatusOption {
  value: string
  label: string
}
